import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CadastroProduct from '../services/productService';

const initialState = {
  error: false,
  success: false,
  loading: false,
  message: null,
  productos: [],
  categorias: {},
  linhas: [],
  inequip: [],
  marcas: {},
  equipamentos: null,
  role: [],
  estoqueBaixo: [],
};

export const cadastroProduct = createAsyncThunk(
  'product/cadastroProduto',
  async (data, thunkAPI) => {
    const response = await CadastroProduct.cadastro(data);
    if (response.errors) {
      return thunkAPI.rejectWithValue(response.errors);
    }
    return response.data;
  }
);

export const cadastroProductCsv = createAsyncThunk(
  'product/cadastroProductCsv',
  async (data, thunkAPI) => {
    const response = await CadastroProduct.cadastroCsv(data);
    if (response.errors) {
      return thunkAPI.rejectWithValue(response.errors);
    }
    return response.data;
  }
);

export const updateProductCsv = createAsyncThunk(
  'product/updateProductCsv',
  async (data, thunkAPI) => {
    const response = await CadastroProduct.updateCsv(data);
    if (response.errors) {
      return thunkAPI.rejectWithValue(response.errors);
    }
    return response.data;
  }
);

export const patchProduct = createAsyncThunk('product/patchProduct', async (data, thunkAPI) => {
  const response = await CadastroProduct.updateProduto(data);
  if (response.errors) {
    return thunkAPI.rejectWithValue(response.errors);
  }
  return response.data;
});

export const postCadastroMaquinario = createAsyncThunk(
  'product/cadastroMaquinario',
  async (data, thunkAPI) => {
    const response = await CadastroProduct.postCadastroMaquinario(data);
    if (response.errors) {
      return thunkAPI.rejectWithValue(response.errors);
    }
    return response.data;
  }
);

export const getCategoriasProduto = createAsyncThunk(
  'product/getCategorias',
  async (_, thunkAPI) => {
    const response = await CadastroProduct.getCategorias();
    if (response.errors) {
      return thunkAPI.rejectWithValue(response.errors);
    }
    return response;
  }
);

export const getLinhas = createAsyncThunk('product/getLinhas', async (_, thunkAPI) => {
  const response = await CadastroProduct.getLinhas();
  if (response.errors) {
    return thunkAPI.rejectWithValue(response.errors);
  }
  return response;
});
export const getMarcas = createAsyncThunk('product/getmarcas', async (_, thunkAPI) => {
  const response = await CadastroProduct.getMarcas();
  if (response.errors) {
    return thunkAPI.rejectWithValue(response.errors);
  }
  return response;
});

export const products = createAsyncThunk('product/products', async (_, thunkAPI) => {
  const response = await CadastroProduct.produtos();
  if (response.errors) {
    return thunkAPI.rejectWithValue(response.errors);
  }
  return response;
});

export const getProdutoInEquipamento = createAsyncThunk(
  'product/getProdutoInEquipamento',
  async (id, thunkAPI) => {
    const response = await CadastroProduct.getProdutoInEquipamento(id);
    if (response.errors) {
      return thunkAPI.rejectWithValue(response.errors);
    }
    return response;
  }
);

export const postProdutoInEquipamento = createAsyncThunk(
  'product/postProdutoInEquipamento',
  async (data, thunkAPI) => {
    const response = await CadastroProduct.postProdutoInEquipamento(data);
    if (response.errors) {
      return thunkAPI.rejectWithValue(response.errors);
    }
    return response.data;
  }
);

export const getEquipamentosAr = createAsyncThunk(
  'product/getEquipamentosAr',
  async (id, thunkAPI) => {
    const response = await CadastroProduct.getEquipamentosAr(id);
    if (response.errors) {
      return thunkAPI.rejectWithValue(response.errors);
    }
    return response;
  }
);

export const getEstoqueBaixo = createAsyncThunk('product/getEstoqueBaixo', async (_, thunkAPI) => {
  const response = await CadastroProduct.getEstoqueBaixo();
  if (response.errors) {
    return thunkAPI.rejectWithValue(response.errors);
  }
  return response;
});

export const postStatusEstoqueBaixo = createAsyncThunk(
  'product/postStatusEstoqueBaixo',
  async (data, thunkAPI) => {
    console.log(data);
    const response = await CadastroProduct.postStatusEstoqueBaixo(data);
    if (response.errors) {
      return thunkAPI.rejectWithValue(response.errors);
    }
    return response;
  }
);

export const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    resetProduct: (state) => {
      state.error = false;
      state.success = false;
    },
    resetEquip: (state) => {
      state.error = false;
      state.equipamentos = null;
    },
    setRole: (state, action) => {
      state.role = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCategoriasProduto.pending, (state) => {
        state.error = null;
        state.success = false;
      })
      .addCase(getCategoriasProduto.fulfilled, (state, action) => {
        state.categorias = action.payload.sort((a, b) =>
          a.nome.localeCompare(b.nome, 'pt-BR', { numeric: true })
        );
      })
      .addCase(getCategoriasProduto.rejected, (state, action) => {
        state.error = action.payload;
        state.success = false;
      })
      .addCase(postCadastroMaquinario.pending, (state) => {
        state.success = false;
        state.loading = true;
        state.error = null;
      })
      .addCase(postCadastroMaquinario.fulfilled, (state, action) => {
        state.loading = false;
        state.categorias = action.payload;
        state.success = true;
      })
      .addCase(postCadastroMaquinario.rejected, (state, action) => {
        state.success = false;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getProdutoInEquipamento.pending, (state) => {
        // state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(getProdutoInEquipamento.fulfilled, (state, action) => {
        // state.loading = false;
        state.success = true;
        state.inequip = action.payload;
      })
      .addCase(getProdutoInEquipamento.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
        state.success = false;
      })

      .addCase(postProdutoInEquipamento.pending, (state) => {
        state.success = false;
        state.loading = true;
        state.error = null;
      })
      .addCase(postProdutoInEquipamento.fulfilled, (state, action) => {
        state.loading = false;
        state.categorias = action.payload;
        state.success = true;
      })

      .addCase(postProdutoInEquipamento.rejected, (state, action) => {
        state.success = false;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getLinhas.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(getLinhas.fulfilled, (state, action) => {
        state.loading = false;
        state.linhas = action.payload;
      })
      .addCase(getLinhas.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(cadastroProduct.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(cadastroProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(cadastroProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(products.pending, (state) => {
        state.success = false;
        state.loading = true;
        state.error = null;
      })
      .addCase(products.fulfilled, (state, action) => {
        state.loading = false;
        // state.success = true;
        state.productos = action.payload;
      })
      .addCase(products.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getMarcas.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(getMarcas.fulfilled, (state, action) => {
        state.loading = false;
        state.marcas = action.payload;
      })
      .addCase(getMarcas.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.success = false;
      })
      .addCase(getEquipamentosAr.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(getEquipamentosAr.fulfilled, (state, action) => {
        state.loading = false;
        state.equipamentos = action.payload;
      })
      .addCase(getEquipamentosAr.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.success = false;
      })
      .addCase(patchProduct.pending, (state) => {
        state.loading = true;
        state.error = false;
        state.success = false;
      })
      .addCase(patchProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(patchProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.success = action.payload;
      })
      // updateProductCsv
      .addCase(updateProductCsv.pending, (state) => {
        state.loading = true;
        state.error = false;
        state.success = false;
      })
      .addCase(updateProductCsv.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(updateProductCsv.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // cadastroProductCsv
      .addCase(cadastroProductCsv.pending, (state) => {
        state.loading = true;
        state.error = false;
        state.success = false;
      })
      .addCase(cadastroProductCsv.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(cadastroProductCsv.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //Estoque Baixo
      .addCase(getEstoqueBaixo.pending, (state) => {
        state.loading = true;
        state.error = false;
        state.success = false;
      })
      .addCase(getEstoqueBaixo.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.estoqueBaixo = action.payload;
      })
      .addCase(getEstoqueBaixo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(postStatusEstoqueBaixo.pending, (state) => {
        state.loading = true;
        state.error = false;
        state.success = false;
      })
      .addCase(postStatusEstoqueBaixo.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(postStatusEstoqueBaixo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetProduct, resetEquip, setRole } = productSlice.actions;
export default productSlice.reducer;
